import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { StartComponent } from './start/start.component';
import {ImpressumComponent} from "./impressum/impressum.component";
import {KontaktComponent} from "./kontakt/kontakt.component";
import {DatenschutzComponent} from "./impressum/datenschutz.component";
import {FaqComponent} from "./faq/faq.component";

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: StartComponent },
      { path: 'start', component: StartComponent },
      { path: 'kontakt', component: KontaktComponent },
      { path: 'faq', component: FaqComponent },
    ],
        {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled', useHash: true})
  ],
  declarations: [
    AppComponent,
    TopBarComponent,
    StartComponent,
    ImpressumComponent,
    DatenschutzComponent,
    KontaktComponent,
    FaqComponent,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
